import * as React from 'react';
import { AutoCompleteAsync } from 'sha-el-design';
import Api from 'requestapijs';
import { Omit } from 'sha-el-design/lib/helpers';
import { UserDetailNodeConnection, UserDetailNodeEdge } from '../../../schema';
import { userDetailDropdownQuery } from './constants';
import { API_URL, HEADER } from '../../config';
import { AutoCompleteAsyncProps } from 'sha-el-design/lib/components/AutoComplete/AutoCompleteAsync';

export class UserDetailDropdown extends React.Component<Props, {}> {
  static defaultProps = {
    extrafields: [],
  };

  constructor(props) {
    super(props);
  }

  fetch = (name: string) =>
    new Promise<UserDetailNodeEdge[]>((resolve, reject) => {
      Api.graphql<{
        name: string,
        userType: string,
        supervisorId: string,
      },
        {
          data: { allUserDetails: UserDetailNodeConnection },
      }>(
        API_URL,
        {
          name,
          userType: this.props.userType,
          supervisorId: this.props.supervisorId || '',
        },
        userDetailDropdownQuery,
        HEADER,
        (v) => resolve(v.data.allUserDetails.edges),
        (e) => reject(e),
      );
    })

  render() {
    return (
      <AutoCompleteAsync
        {...this.props}
        mode='single'
        data={(v) => this.fetch(v)}
        inputProps={{
          ...this.props.inputProps,
        }}
        filterFunction={() => true}
      />
    );
  }
}

interface Props extends Omit<AutoCompleteAsyncProps<UserDetailNodeEdge>, 'data'> {
  userType: string;
  mode: 'single';
  value: UserDetailNodeEdge;
  onChange: (value: UserDetailNodeEdge) => void;
  supervisorId?: string;
}
